import React, { createContext, useState, useEffect, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const AuthContext = createContext();

// 認証不要なパスのリストを定義
export const PUBLIC_PATHS = ['/customer', '/signin', '/register', '/reset-password'];

// AuthContextのチェックポイント
export const RequireAuth = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const checkAuth = () => {
      const isPublicPath = PUBLIC_PATHS.some(path => 
        location.pathname.startsWith(path)
      );

      // パブリックパスの場合は認証チェックをスキップ
      if (isPublicPath) {
        return;
      }

      // 非パブリックパスで未認証の場合のみリダイレクト
      if (!isAuthenticated && !isLoading) {
        history.push('/signin');
      }
    };

    checkAuth();
  }, [isAuthenticated, isLoading, location, history]);

  // パブリックパスの場合は常に表示
  const isPublicPath = PUBLIC_PATHS.some(path => 
    location.pathname.startsWith(path)
  );

  if (isPublicPath) {
    return children;
  }

  // 非パブリックパスの場合は認証状態をチェック
  return isAuthenticated ? children : null;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const init = async () => {
      await checkAuthState();
    };
    init();
  }, []);

  const checkAuthState = async () => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      setUser(currentUser);
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      setIsAuthenticated, 
      isLoading ,
      user,
      setUser 
    }}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};

export { AuthContext };
